@if (product().data?.media | findMediaByLabel : 'dimensions') {
<div class="w-12 ratio-1-1 _image-wrapper">
    <img #image
         class="rf"
         (click)="zoomIn()"
         [image]="getImage()">
</div>
}
<product-view-dimensions-and-details [product]="product()"
                                     [rightView]="!client.isS"
                                     [icons]="content().dimensions_icons"
                                     [topAttributes]="content().dimensionsTopAttributes"
                                     [sections]="content().dimensions_sections" />